import { CSSProperties } from 'react';
import { ActiveUserMenuComponent } from './active-user-menu.component';
import { SignupLoginButtonView } from './signup-login-button.component';
import { MyDataRequestsButtonView } from './my-data-requests-button.component';
import { EnquiryLinkComponent } from './enquiry-link.component';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { useUserPermissions } from '@vivli/features/users/infrastructure/hook';
import { useActiveUserContext, useAppConfigContext, useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';
import { TopLinksMenuComponent } from './top-links-menu.component';

export const SubHeaderComponent = () => {
    const { user, hasPermission, hasAnyPermission } = useActiveUserContext();
    const { myDataRequestsEnabled } = useAppConfigContext();
    const { isAmr } = useAssignedAppTypeContext();
    const { isOrgOrVivliAdmin, isAnnotator, isQaReviewer, isIRPApprover } = useUserPermissions();

    const isVivliAdmin = hasPermission(PermissionsEnum.DrActAdv);
    const isDataProviderEnq = isOrgOrVivliAdmin && hasAnyPermission(PermissionsEnum.DataContrib);
    let isRelevantOther = false;
    if (isAnnotator || isIRPApprover || isQaReviewer) {
        isRelevantOther = true; // this had to be simplified to accomodate TypeScript limitations
    }

    //Enquiry link should only be visible for logged out nonAMR users
    let canSeeEnquiry = !user;
    if (
        //TODO PERMFE - replace to permissions+
        isAmr ||
        (isDataProviderEnq && !isOrgOrVivliAdmin && !isVivliAdmin) ||
        (isRelevantOther && !isDataProviderEnq && !isVivliAdmin)
    ) {
        canSeeEnquiry = false;
    }

    const columnCount = (canSeeEnquiry ? 1 : 0)
        + (isAmr && user && (myDataRequestsEnabled || isVivliAdmin) ? 1 : 0)
        + (!isAmr && user ? 1 : 0)
        + (isAmr && user ? 1 : 0)
        + (!user ? 1 : 0);

    const containerStyle: CSSProperties = {
        display: 'grid',
        gridTemplateColumns: `repeat(${columnCount}, auto)`,
        gap: '10px',
        padding: '0px 10px',
        height: '100%',
        width: '100%'
    };

    return (
        <div style={containerStyle}>
            {/*enquiry is now only ever visible for logged out users*/}
            {canSeeEnquiry && <EnquiryLinkComponent />}

            {
                //only Amr users see My Data Requests button now
                //TODO PERMFE -replace to permissions+
                isAmr && user && (myDataRequestsEnabled || isVivliAdmin) && <MyDataRequestsButtonView />
            }

            {/*logged in CT users see the Top Tabs, which includes a right hand menu for mgmt/auth tasks only*/}
            {!isAmr && user && <TopLinksMenuComponent />}

            {/*logged in AMR users see the original right-hand menu that includes all tasks*/}
            {isAmr && user && <ActiveUserMenuComponent />}

            {/*users NOt LOGGED in see signup + log in only, in addition to enquiry for CT users*/}
            {!user && <SignupLoginButtonView />}
        </div>
    );
};
